<!--
    Created by 程雨喵'mac on 2024/10/21.
    Copyright © 2024年 云柜-金星晖. All rights reserved.
    功能概述：计费设置-按时间计费
-->
<style lang="less">
.device-price-use-time {
  .type-tit {
    padding-bottom: @containerGap;
    font-weight: 600;
    color: @textColorLight;
  }
  // 表单行：标签列宽 120px 与弹窗 FormItem 的 label-width 对齐
  .form-row {
    display: flex;
    align-items: flex-start;
    padding-bottom: 12px;
    font-size: 12px;
    .form-row-label {
      width: 120px;
      flex: 0 0 120px;
      padding-right: 8px;
      text-align: right;
      line-height: @formHeight;
    }
    .form-row-value {
      flex: 1;
      min-width: 0;
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      min-height: @formHeight;
      line-height: @formHeight;
      .ivu-input-number {
        width: 90px;
        flex: 0 0 90px;
        margin-right: 8px;
        padding-right: 0;
        .ivu-input-number-handler-wrap {
          display: none;
        }
      }
      .row-unit {
        color: @textColorLight;
      }
    }
  }
  // 说明框上间距
  // （注意：项目里的 margin-primary-top 未定义，此处本地补齐）
  .alert-gap {
    margin-top: @containerGap;
  }
  // 说明文案尺寸与表单保持一致（与 useElectric 相同处理）
  .ivu-alert-with-desc {
    padding: @containerGap * 0.5 @containerGap;
    .ivu-alert-message {
      font-size: 13px;
    }
    .ivu-alert-desc {
      font-size: 12px;
      line-height: 18px;
    }
  }
}
</style>

<template>
  <div class="device-price-use-time">
    <!-- ==================== 计费规则 ==================== -->
    <div class="type-tit">
      <span v-if="isEdit">设置</span>计费规则
    </div>

    <!-- 充电金额（固定） -->
    <div class="form-row">
      <div class="form-row-label">
        充电金额
      </div>
      <div class="form-row-value">
        <span>{{ currentPrice }} 元（固定，不随功率、电量变化）</span>
      </div>
    </div>

    <!-- 可充电时长 -->
    <div class="form-row">
      <div class="form-row-label">
        可充电时长
      </div>
      <div class="form-row-value">
        <template v-if="isEdit">
          <InputNumber
            v-model="dataList[0].chargeDuration"
            :min="0"
          />
          <span class="row-unit">分钟</span>
        </template>
        <span v-else>{{ currentDuration }} 分钟</span>
      </div>
    </div>

    <!-- ==================== 说明 ==================== -->
    <Alert
      v-if="isEdit"
      class="alert-gap"
    >
      说明
      <template slot="desc">
        <p>1、充电金额固定为{{ currentPrice }}元，与充电功率、电量无关；</p>
        <p>2、{{ currentPrice }}元可充电{{ currentDuration }}分钟，不足1分钟按1分钟收费；</p>
        <p>3、结算金额按小数点后第3位四舍五入取参；</p>
        <p>4、该计费模式不支持大功率设备，若设备运营参数中设置了功率上限，超出后会自动断电并退款。</p>
      </template>
    </Alert>
  </div>
</template>

<script>

export default {
  components: {},
  props: {
    isEdit: {
      type: Boolean,
      default: false
    },
    dataList: {
      type: Array,
      default: () => {
        return [];
      }
    }
  },
  data () {
    return {};
  },
  computed: {
    // 充电金额固定为 1 元
    currentPrice () {
      const item = this.dataList[0];
      return item && item.price ? item.price : 1;
    },
    // 1 元可充电时长（分钟）
    currentDuration () {
      const item = this.dataList[0];
      return item && item.chargeDuration ? item.chargeDuration : '-';
    }
  },
  methods: {
    $checkSubmit () {
      const item = this.dataList[0];
      if (!item || !item.chargeDuration || Number(item.chargeDuration) <= 0) {
        return { success: false, msg: this.$Message.warning('充电时长填写有误') };
      }
      return { success: true };
    }
  }
};
</script>
